import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { map, share } from "rxjs/operators";
import { OnboardingTaskService } from "../models/onboarding-task.service";

@Injectable()
export class OnboardingTaskStateService {
  public calloutTask: any;
  public checklistTasks: any;
  public completedCount: number;

  private project: any;
  private reloadObservable: Observable<any>;

  constructor(private onboardingTaskService: OnboardingTaskService) {}

  // NOTE: an alternative is to cache this at the model layer with project ID.
  public initForProject(project: any) {
    if (project !== this.project) {
      this.project = project;
      this.reloadObservable = this.reloadTasks();
    }

    return this.reloadObservable;
  }

  public reloadTasks() {
    return this.onboardingTaskService
      .index({ projectId: this.project.id })
      .pipe(
        map((data: any) => {
          this.checklistTasks = data.tasks.filter(
            // This can be changed to `state === "checklist" if we don't want
            // to show completed tasks.
            (t: any) => ["checklist", "complete"].indexOf(t.state) >= 0,
          );
          this.calloutTask = data.tasks.find((t: any) => t.state === "callout");
          this.completedCount = data.tasks.filter(
            (t: any) => t.state === "complete",
          ).length;
        }),
        share(),
      );
  }
}
